// ── Lot step times — one dialog for the whole app ────────────────────────────
//
// The server refuses a lot moving on while a step it went through has no start or
// finish (409 `step_times_missing`, flag `stageTimeCapture`). The axios interceptor
// hands that refusal here; `StepTimesDialog` (mounted once in Layout) asks for the
// times and the original request is retried — so Submit, Send and Complete on any
// screen work without that screen knowing the rule exists.

let handler = null;

export const STEP_TIMES_CHANGED = 'stepTimes:changed';

export function registerStepTimesHandler(fn) {
  handler = fn;
  return () => { if (handler === fn) handler = null; };
}

// Resolves true once times were saved, false when the dialog was closed.
export function askForStepTimes(request) {
  if (!handler) return Promise.resolve(false);
  return handler(request);
}

// "Fill in times" from a dashboard row or a lot screen.
export function openStepTimes({ tankLotId, productionLotId, lotCode, steps } = {}) {
  return askForStepTimes({ tankLotId, productionLotId, lotCode, steps, mode: 'edit' });
}

export function announceStepTimesChanged(detail) {
  try {
    window.dispatchEvent(new CustomEvent(STEP_TIMES_CHANGED, { detail }));
  } catch {
    /* nothing listening is fine */
  }
}

export function isStepTimesRefusal(error) {
  const d = error?.response?.data?.detail;
  return error?.response?.status === 409 && d && typeof d === 'object' && d.code === 'step_times_missing';
}
